import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ffad2e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid gap-y-4 grid-cols-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header text-xl font-medium" }, "Procedure", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header text-xl font-medium" }, "Recommendation", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header text-xl font-medium" }, "Clinical Review", -1))
const _hoisted_5 = { class: "procedure text-lg my-auto" }
const _hoisted_6 = { class: "procedure-code" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-3 bg-gray-100 rounded mb-4 px-4 py-4"
}
const _hoisted_9 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selected", -1))
const _hoisted_11 = { class: "font-mono bg-blue-200 mx-1 px-2 py-1 rounded" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "as an alternative criterion.", -1))
const _hoisted_13 = { class: "border-l-4 pl-4 py-2 border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Recommendation = _resolveComponent("Recommendation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.procedureReviews, (procedureReview, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(procedureReview.code), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getPolicyName(i)), 1)
        ]),
        _createVNode(_component_Recommendation, {
          class: "recommendation uppercase my-auto",
          status: String(_ctx.getRecommendationStatus(i))
        }, null, 8, ["status"]),
        _createVNode(_component_Recommendation, {
          class: "payer-review uppercase my-auto",
          status: _ctx.getApprovalStatus(procedureReview.approved)
        }, null, 8, ["status"]),
        (_ctx.hasComments(procedureReview))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (procedureReview.selectedCriteria)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(procedureReview.selectedCriteria), 1),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procedureReview.comments.split('\n'), (paragraph, p) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "paragraph text-gray-600",
                    key: p
                  }, _toDisplayString(paragraph), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}